import Vue from 'vue';
import * as types from '@/store/mutation-types';

export default {
  [types.addProjectUserItem](state, { project, userList }) {
    project[userList].push({ occupation: '', companyId: '', personId: '' });
  },
  [types.updateProjectUserItem](state, { userItem, property, newValue }) {
    userItem[property] = newValue;
  },
  [types.addProject](state, project) {
    if (!state.projectList.find((p) => p._id === project._id)) {
      state.projectList.push(project);
    }
  },
  [types.setProjectList](state, list) {
    Vue.set(state, 'projectList', list);
  },
  [types.setProject](state, project) {
    state.currentProject = project;
  },
  [types.setParts](state, parts) {
    Vue.set(state, 'parts', parts);
  },
  [types.selectDiaryEntry](state, diaryEntry) {
    if (state.selectedDiaryEntry === diaryEntry) {
      return;
    }
    state.selectedDiaryEntry = diaryEntry;
  },
  [types.selectPart](state, part) {
    if (state.selectedPart === part) {
      return;
    }
    Vue.set(state, 'selectedPartInspection', null);
    Vue.set(state, 'selectedPartTodoItems', []);
    state.selectedPart = part;
  },
  [types.selectStage](state, stage) {
    if (state.selectedStage === stage) {
      return;
    }
    state.selectedStage = stage;
  },
  [types.deletePart](state, deleteRequest) {
    deleteRequest.parent.splice(deleteRequest.index, 1);
  },
  [types.addPart](state, update) {
    if (!update.parent) {
      update.parent = state.currentProject.children;
    }
    var pPart = { _id: update.newPart._id, title: update.newPart.title, type: 'Part' };
    if (update.index) {
      update.parent.splice(update.index, 0, pPart);
    } else {
      update.parent.unshift(pPart);
    }

    if (!state.parts[update.newPart._id]) {
      Vue.set(state.parts, update.newPart._id, update.newPart);
    }
  },
  [types.addSyncedPart](state, part) {
    if (!state.parts[part._id]) {
      Vue.set(state.parts, part._id, part);
    }
  },
  [types.setStages](state, stages) {
    Vue.set(state, 'stages', stages);
  },
  [types.deleteStage](state, deleteRequest) {
    deleteRequest.parent.splice(deleteRequest.index, 1);
  },
  [types.addStage](state, update) {
    if (!update.parent) {
      update.parent = state.currentProject.children;
    }
    if (!update.parent.find((p) => p._id === update.newStage._id)) {
      var pStage = {
        _id: update.newStage._id,
        title: update.newStage.title,
        children: update.newStage.children,
        type: 'Stage',
      };
      if (update.index) {
        update.parent.splice(update.index, 0, pStage);
      } else {
        update.parent.unshift(pStage);
      }
    }
    if (!state.stages[update.newStage._id]) {
      Vue.set(state.stages, update.newStage._id, update.newStage);
    }
  },
  [types.addSyncedStage](state, stage) {
    if (!state.stages[stage._id]) {
      Vue.set(state.stages, stage._id, stage);
    }
  },
  [types.setProjectProperties](state, update) {
    Object.assign(update.updateProject, update.newProjectProperties);
  },
  [types.setPartProperties](state, update) {
    Object.assign(update.updatePart, update.newPartProperties);

    // if (update.newPartProperties.title) {
    //   updateProjectChild(state.currentProject.children, update.updatePart);
    // }
  },
  [types.setStageProperties](state, update) {
    Object.assign(update.updateStage, update.newStageProperties);

    // if (update.newStageProperties.title) {
    //   updateProjectChild(state.currentProject.children, update.updateStage);
    // }
  },
  [types.addProjectUserItemByIndex](state, { project, userList, index }) {
    // console.log(index);
    state.currentProject[userList].splice(index, 0, { occupation: '', companyId: '', personId: '' });
    // project[userList].splice(index, 0, {occupation: occupation, companyId: "", personId: ""});
  },
  [types.updateProjectUserItemOccupation](state, { project, userList, index, occupation }) {
    // console.log(index, occupation);
    Vue.set(state.currentProject[userList], index, { occupation: occupation, companyId: '', personId: '' });
    // Vue.set(project[userList], index, {occupation: occupation, companyId: "", personId: ""});
  },
  [types.deleteProjectUserItem](state, { project, userList, index }) {
    state.currentProject[userList].splice(index, 1);
    // console.log(JSON.stringify(state.currentProject[userList]));
  },
};



// WEBPACK FOOTER //
// ./src/store/project/projectMutations.js